<template>
  <component
    :is="applicationInfoComponent"
    v-bind="applicantInfoComponentProps"
    v-on="currentListeners"
  ></component>
  <component :is="modalComponent"></component>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { ProductIds } from "@/config/constants";
import ApplicationInfoLOC from "@/components/application-info/ApplicationInfoLOC.vue";
import ApplicationInfoPEL from "@/components/application-info/ApplicationInfoPEL.vue";
import ApplicationInfoREFI from "@/components/application-info/ApplicationInfoREFI.vue";
import RefiLoanDetailsModal from "@/components/modals-refi/RefiLoanDetailsModal.vue";
import RefiLoanConfigurationModal from "@/components/modals-refi/RefiLoanConfigurationModal.vue";
import ConfirmYourRefinanceDetailsModal from "@/components/modals-refi/ConfirmYourRefinanceDetailsModal.vue";

const props = defineProps({
  id: {
    type: String,
  },
  application: {
    type: Object,
    required: true,
  },
  applicant: {
    type: Object,
    required: true,
  },
});

const store = useStore();

const emit = defineEmits(["complete", "hydrateStore"]);

const productTypeId = computed(() => store?.state?.appData?.application?.productTypeId);
const currentlyActiveModal = computed(() => store.getters["applicationInfoModule/ModalComponent"]);
const applicationInfoComponent = computed(() => {
  return getApplicationInfoComponent();
});
const modalComponent = computed(() => {
  return getModalComponent();
});
const applicantInfoComponentProps = computed(() => {
  switch (applicationInfoComponent.value) {
    case ApplicationInfoLOC:
      return { application: props.application, applicant: props.applicant };
    case ApplicationInfoREFI:
      return { application: props.application };
    default:
      return undefined;
  }
});
const currentListeners = computed(() => {
  switch (applicationInfoComponent.value) {
    default:
      return {};
  }
});

function getModalComponent() {
  switch (currentlyActiveModal.value) {
    case "LoanDetails":
      return RefiLoanDetailsModal;
    case "InterestRateAndLoanTerm":
      return RefiLoanConfigurationModal;
    case "ConfirmYourRefinanceDetails":
      return ConfirmYourRefinanceDetailsModal;
    default:
      return;
  }
}

function getApplicationInfoComponent() {
  switch (productTypeId.value) {
    case ProductIds.REFI:
      return ApplicationInfoREFI;
    case ProductIds.LOC:
      return ApplicationInfoLOC;
    case ProductIds.PEL:
      return ApplicationInfoPEL;
    default:
      return undefined;
  }
}

function handleHydrateStoreEvent() {
  emit("hydrateStore");
}

function handleCompleteEvent(event: any) {
  emit("complete", event);
}
</script>
